import { render, staticRenderFns } from "./clinicsCategorySelectGoods.vue?vue&type=template&id=b5f54d3c&scoped=true"
import script from "./clinicsCategorySelectGoods.vue?vue&type=script&lang=js"
export * from "./clinicsCategorySelectGoods.vue?vue&type=script&lang=js"
import style0 from "./clinicsCategorySelectGoods.vue?vue&type=style&index=0&id=b5f54d3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f54d3c",
  null
  
)

export default component.exports